export enum RoleDialogType {
  None = '',
  Add = 'Add',
  Edit = 'Edit',
  View = 'View',
  Delete = 'Delete',
}
